// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__28qQM","range":"MonthRangeSwitch_range__16ieu","disabled":"MonthRangeSwitch_disabled__28clR"};